import { render, staticRenderFns } from "./DefaultDialog.vue?vue&type=template&id=532bf04a"
import script from "./DefaultDialog.vue?vue&type=script&lang=js"
export * from "./DefaultDialog.vue?vue&type=script&lang=js"
import style0 from "./DefaultDialog.vue?vue&type=style&index=0&id=532bf04a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports